import { forwardRef } from "react";
import styled from "styled-components";

import { withSubComponents } from "capitalrx-components-2.0";
import { CheckboxGroup, CheckboxGroupProps, CheckboxGroupSubComponents, RefComponent } from "capitalrx-components-2.0/lib/forms";
import { Field } from "capitalrx-components-2.0/lib/forms/CheckboxGroup/Field";
import { Group } from "capitalrx-components-2.0/lib/forms/CheckboxGroup/Group";
import { Option } from "capitalrx-components-2.0/lib/forms/CheckboxGroup/Option";
import { Placeholder } from "capitalrx-components-2.0/lib/forms/CheckboxGroup/Placeholder";

import "./Checkbox.scss";
import "./CheckboxGroup.scss";

const _ThemedCheckboxGroupField = styled(Field)`
  .checked,
  .check {
    &:focus {
      box-shadow: 0px 0px 4px ${(props) => props.theme.primary_button_color} !important;
    }
  }

  .checked {
    .check-container {
      background-color: ${(props) => props.theme.primary_button_color} !important;
      border-color: ${(props) => props.theme.primary_button_color} !important;
    }
  }
`;

const _ThemedCheckboxGroup = styled(CheckboxGroup)`
  .checked,
  .check {
    &:focus {
      box-shadow: 0px 0px 4px ${(props) => props.theme.primary_button_color} !important;
    }
  }

  .checked {
    .check-container {
      background-color: ${(props) => props.theme.primary_button_color} !important;
      border-color: ${(props) => props.theme.primary_button_color} !important;
    }
  }
`;

interface ThemedCheckboxGroupSubComponents extends CheckboxGroupSubComponents {
  readonly Field: typeof _ThemedCheckboxGroupField;
}

export const ThemedCheckboxGroup = withSubComponents<RefComponent<HTMLInputElement, CheckboxGroupProps>, ThemedCheckboxGroupSubComponents>(
  {
    Field: _ThemedCheckboxGroupField,
    Option,
    Group,
    Placeholder,
  },
  forwardRef(function FRThemedCheckboxGroup(props, ref) {
    return <_ThemedCheckboxGroup { ...props } ref={ref} />;
  }),
);
